export default __webpack_public_path__ + "static/media/013-graduate.ecc8ad3b.svg";